/** Popup callback for the session portal's in-memory PKCE authorization flow. */
import { useEffect } from "react";
import { useLocation } from "react-router";

import {
  GOOGLE_MEET_OAUTH_MESSAGE_TYPE,
  googleMeetOAuthChannelName,
} from "@/lib/google-meet-oauth";

export function GoogleMeetOAuthCallbackPage() {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const message = {
      type: GOOGLE_MEET_OAUTH_MESSAGE_TYPE,
      state: query.get("state") ?? undefined,
      code: query.get("code") ?? undefined,
      error: query.get("error") ?? undefined,
    };
    const state = typeof message.state === "string" ? message.state : "";
    if (state && typeof BroadcastChannel !== "undefined") {
      // A Google navigation may sever window.opener through cross-origin
      // isolation. BroadcastChannel remains available when this callback is
      // back on the portal's origin and never persists the OAuth result.
      const channel = new BroadcastChannel(googleMeetOAuthChannelName(state));
      channel.postMessage(message);
      channel.close();
    }
    if (window.opener) window.opener.postMessage(message, window.location.origin);
    window.setTimeout(() => window.close(), 50);
  }, [location.search]);

  return <p className="p-6 text-ui text-muted-foreground">Returning to the session…</p>;
}
